import { atom } from 'jotai'

type Input = {
  isAutoInitialHideEnabled: boolean
}

const state = atom<Input>({
  isAutoInitialHideEnabled: true,
})
export const globalLoadingStore = { state } as const
